import {StyleSheet} from 'react-native';

export const stylesFn = () =>
  StyleSheet.create({
    fullScreenContainer: {
      ...StyleSheet.absoluteFillObject,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
    confetti: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'stretch',
      paddingHorizontal: 38.5,
    },
    dialogBox: {
      backgroundColor: 'white',
      borderRadius: 15,
      overflow: 'hidden',
    },
    headerContainer: {
      backgroundColor: 'white',
      justifyContent: 'center',
      alignItems: 'center',
      paddingVertical: 20,
    },
    contentContainer: {
      backgroundColor: 'white',
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 20,
    },
    rightIconButton: {
      position: 'absolute',
      top: 16,
      right: 16,
    },
    rightIcon: {
      height: 18,
      width: 18,
    },
  });
